import axios, { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { getHeaders } from 'lib/core/services/magento/client/utils'

interface CustomerPasswordMutationInput {
  payload: {
    email: string
    websiteId: number
    template: string
  }
}

export type CustomerPasswordMutation = (input: CustomerPasswordMutationInput) => Promise<AxiosResponse<any>>

export const createCustomerPasswordMutation = (deps: ServiceDependencies): CustomerPasswordMutation => async ({ payload }) => {
  return axios.put('/V1/customers/password', payload, {
    headers: getHeaders()
  })
}
